import type { EventType } from '@fellowship/shared'
import { EventTypePicker } from './EventTypePicker'
import { Field } from './EventFormPrimitives'

// Basics: event type (optional — hidden on edit), title, description.
// Shared by CreatePersonEventPage (guided + form) and EditPersonEventPage.

export function BasicsFields({
  eventType,
  onTypeChange,
  showTypePicker = true,
  title,
  onTitleChange,
  titleError,
  description,
  onDescriptionChange,
}: {
  eventType: EventType
  onTypeChange: (key: EventType) => void
  showTypePicker?: boolean
  title: string
  onTitleChange: (value: string) => void
  titleError?: string
  description: string
  onDescriptionChange: (value: string) => void
}) {
  return (
    <div className="flex flex-col gap-4">
      {showTypePicker && <EventTypePicker value={eventType} onChange={onTypeChange} />}
      <Field label="Title" htmlFor="title" required error={titleError}>
        <input
          id="title"
          type="text"
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          placeholder="Weekend morning hike"
          aria-invalid={Boolean(titleError)}
          className="input"
        />
      </Field>
      <Field label="Description" htmlFor="description">
        <textarea
          id="description"
          rows={3}
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="What guests can expect, what to bring…"
          className="input resize-y h-auto py-3 px-3.5 leading-[1.5]"
        />
      </Field>
    </div>
  )
}
